export default {
  nonTimeparkTaskName: 'kein Projekt ausgewählt',
  metadata: {
    typeText: 'text',
    typeNumber: 'number',
    typeDate: 'date',
    typeOption: 'option',
  }
};
